import script from "./ServicesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSlide.vue?vue&type=script&setup=true&lang=js"

import "./ServicesSlide.vue?vue&type=style&index=0&id=2fa8ac06&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa8ac06"]])

export default __exports__